// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4020ec77] .btn{width:130px !important;text-transform:capitalize !important;font-size:14px !important}", ""]);
// Exports
module.exports = exports;
